var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Source reliable distributors across Africa")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Asoko provides tailored research-as-a-service to support the world’s leading corporates in navigating Africa’s distribution and reseller landscape. Businesses operating across the continent save time and money using Asoko’s market mapping solutions to better understand their business environment. A tailor-built market map can help you shortlist and verify all the top companies in your target country, industry or sub-sector, enabling you to source legitimate trade partners to fit your growth plans across the continent."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Learn More About Market Maps")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }